export default class View {
	constructor(shallowLine, steepLine, shallowBump, steepBump) {
		this.shallowLine = shallowLine;
		this.steepLine = steepLine;
		this.shallowBump = shallowBump;
		this.steepBump = steepBump;
	}
	clone() {
		return new View(this.shallowLine.clone(), this.steepLine.clone(), this.shallowBump ? this.shallowBump.clone() : undefined, this.steepBump ? this.steepBump.clone() : undefined);
	}
}